import { createContext, useContext, useState } from "react";

const EngineeringReportFiltersContext = createContext();

export const EngineeringReportFiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState({}); 

  const clearFilters = () => setFilters({});

  return (
    <EngineeringReportFiltersContext.Provider value={{ filters, setFilters, clearFilters }}>
      {children}
    </EngineeringReportFiltersContext.Provider>
  );
};

export const useEngineeringReportFilters = () => useContext(EngineeringReportFiltersContext);
